module.exports = __webpack_public_path__ + "img/earth.0340e69c.png";